import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { ApplicationHttpService } from "../../../core/services/application-http.service";
import { OverviewModel } from "../../../shared/models/overview.model";
import { BackOfficeOverview, BackOfficeRequest } from "./back-office-overview.model";
import { environment } from "../../../../environments/environment";

/** List / overview / export / filter values for the back-office application list. */
@Injectable()
export class ApplicationListService {

    constructor(private http: ApplicationHttpService, private httpClient: HttpClient) {
    }

    getListNew(request: BackOfficeRequest): Observable<BackOfficeOverview> {
        return this.http.get<BackOfficeOverview>(`back-office-application/list`, request.params());
    }

    getList(params: string, body: any): Observable<OverviewModel> {
        return this.http.post<OverviewModel>(`back-office-application/overview`, body, {params});
    }

    exportListToExcel(request: BackOfficeRequest): Observable<Blob> {
        return this.httpClient.get(`${environment.publicEndpoint}/back-office-application/export`, {
            params: new HttpParams({ fromString: request.paramsExport() }),
            headers: new HttpHeaders({
                Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            }),
            responseType: 'blob' as const
        });
    }

    getFilterValues(): Observable<any> {
        return this.http.get<any>(`back-office-application/filter-values`);
    }
}
